import {requests} from "../../helpers/api.services";
import {JOB_URL} from "../../helpers/api.routes";
import {IPagination} from "../../shared/interface";

export const AdminJobService = {
    getAll: (params: IPagination) => requests.get(`${JOB_URL}`, params),
    create: (payload: FormData) => requests.post(`${JOB_URL}`, payload, true),
    getSingle: (id: number) => requests.get(`${JOB_URL}/${id}`),
    update: (payload: FormData, id: number) => requests.post(`${JOB_URL}/${id}`, payload, true),
    delete: (id: number) => requests.delete(`${JOB_URL}/${id}`),
    updatePosition: (ids: number[]) => requests.patch(`${JOB_URL}`, {ids}),
}